import styled from 'utils/styled';

export const Container = styled.div``;

export const HiddenContainer = styled.div`
  /* display: none; */
  width: 1024px;
  padding: 16px;
`;

export const Header = styled.div`
  display: flex;
  /* align-items: center;
  justify-content: space-between; */
  flex-direction: column;
  margin-bottom: 40px;
`;

export const UnsubmittedEmailsContainer = styled.div`
  display: flex;
`;

